"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapToolTip = void 0;
var Feature_1 = require("ol/Feature");
var MapToolTip = /** @class */ (function () {
    function MapToolTip(map, toolTipProvider, toolTipOptions) {
        var _this = this;
        this.map = map;
        this.toolTipProvider = toolTipProvider;
        this.toolTipOptions = toolTipOptions;
        this.initialised = false;
        this.init = function () {
            if (!_this.initialised) {
                _this.initOnHoverTooltip();
                _this.initialised = true;
            }
        };
        this.initOnHoverTooltip = function () {
            var self = _this;
            self.ttipElement = $('#mapFeatureTooltip').tooltip({
                animation: false,
                trigger: 'manual',
                html: true,
                container: '#theMap'
            });
            //close the tooltip if we leave the map
            $("#" + self.map.olMap.getTargetElement().id).mouseleave(function () {
                self.ttipElement.tooltip('hide');
            });
            $("#slide-panel").mouseenter(function () {
                self.ttipElement.tooltip('hide');
            });
            var closeTimeout = null;
            var displayFeatureInfo = function (pixel) {
                self.ttipElement.css({
                    left: pixel[0] + 'px',
                    top: (pixel[1] - 15) + 'px'
                });
                var toolTips = [];
                self.map.olMap.forEachFeatureAtPixel(pixel, function (feature, layer) {
                    if (feature instanceof Feature_1.default) {
                        var ttip = self.toolTipProvider.getToolTip(feature, layer);
                        if (ttip && toolTips.indexOf(ttip) === -1) {
                            toolTips.push(ttip);
                        }
                    }
                });
                if (toolTips.length > 0) {
                    var ttip = "";
                    var ttipCount = (toolTips.length > self.toolTipOptions.maxToolTipCount) ? self.toolTipOptions.maxToolTipCount : toolTips.length;
                    for (var i = 0; i < ttipCount; i++) {
                        ttip += "<div class='map-tooltip-inner'>" + toolTips[i] + "</div>";
                    }
                    if (ttipCount < toolTips.length) {
                        ttip += "<div>...</div>";
                    }
                    window.clearTimeout(closeTimeout);
                    self.ttipElement.tooltip('hide')
                        .attr('data-bs-original-title', ttip)
                        .tooltip('show');
                }
                else {
                    self.ttipElement.tooltip('hide');
                }
            };
            self.zoomLevel = _this.map.olMap.getView().getZoom();
            _this.map.olMap.on('pointermove', function (evt) {
                if (self.zoomLevel >= self.toolTipOptions.minZoomLevel) {
                    //or the popup is open
                    if (evt.dragging) {
                        self.ttipElement.tooltip('hide');
                        return;
                    }
                    displayFeatureInfo(self.map.olMap.getEventPixel(evt.originalEvent));
                }
            });
            _this.map.onZoomChanged.subscribe(self.onZoomChanged);
        };
        this.onZoomChanged = function (args) {
            console.log("Map popup zoom level changed: " + args.zoomLevel);
            _this.zoomLevel = args.zoomLevel;
        };
        this.init();
    }
    return MapToolTip;
}());
exports.MapToolTip = MapToolTip;
//# sourceMappingURL=MapToolTip.js.map